import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { UPDATE_CARDNAME, STATUS_SUCCESS_CODE, CAN_CREATE_SAVINGS_ACC, PAID_PROMO_KEY } from '../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils';
import LineBreaks, { addLineBreaks, displayErrorMessage, displaySuccessMessage, MoreServices, retrieveData } from '../../../utils';
import check_img from '../../../assets/kudzu-plus-images/Approved_Black.png'
import beneficiarysaving from '../../../assets/images/beneficiarysaving.png';
import KudzuPlusImage from '../../../assets/kudzu-plus-images/KudzuPluseLogo.png';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import FooterContent from '../../../components/CustomComponents/Footer';
import HomeLayout from '../../../components/Layout/HomeLayout';
import HomeHeader from '../../../components/CustomComponents/HomeHeader';
import DynamicCard from '../../../components/CustomComponents/DynamicCard';
import Loader from '../../../components/CustomComponents/Loader';
import CustomAlertModel from '../../../components/CustomComponents/CustomAlertModel';
import { width } from '../../../components/CustomComponents/DynamicCard/DynamicCardStyles';
import CustomModalPlus from '../../helpers/customModalPlus';
import MemnershipEnrollmentScreens from "../../../kudzu_plus/components/membershipEnrollmentScreens";
import logFirebaseEvents from '../../../components/LogFirebaseEvents';
import Cookies from 'js-cookie';


// import DynamicCard from '../../../../CustomComponents/DynamicCard';

const ManageMembershipKudzu = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation(); // Hook to access translation functions
    const cards = useSelector(state => JSON.parse(state.userCards));
    const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [editClicked, setEditClicked] = useState(false);
    const [showCheckImage, setshowCheckImage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isMembershipDismissed, setIsMembershipDismissed] = useState(false);


    const selectedItem = cards?.[0]
    const [newName, setNewName] = useState((selectedItem != undefined && selectedItem != null) ? selectedItem.NickName : "");

    const [loading, setLoading] = useState(false)
    const [infoMessage, setinfoMessage] = useState('');
    const [responseCode, setResponseCode] = useState('');
    const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const HeaderMsgStylesForPlus = "font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[13px] sm:text-[6px] text-[8px] font-[400] cursor-pointer pointer-events-none";
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [showModel, setShowModel] = useState(false);
    const [modelImage, setModelImage] = useState('')
    const [savingsTheme, setSavingsTheme] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [isSubFooter, setIsSubFooter] = useState(false);
    const [carousel, setCarousel] = useState('');
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [skipAndNextButtonsEnable, setSkipAndNextButtonsEnable] = useState(false);
    const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);

    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const [promoKey,setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
    const currentpath = useLocation()
    const [btn1TextColor, setBtn1TextColor] = useState("");
    




    const subObjectsArray = cards?.map(card => {
        return {
            AccountTypeName: card.AccountTypeName,
            CardKey: card.CardKey,
            OpenDate: card.ApplicationDate
        };
    });
    if (savingsCardAvailable == false) {
        const staticObject = {
            AccountTypeName: t('menu_savings'),
            CardKey: '',
            OpenDate: 'empty'
        };
        // subObjectsArray?.push(staticObject);
        subObjectsArray?.splice(1, 0, staticObject);
    }



    const subComponent = () => {
        return (
            <div className=' flex justify-start items-start'>
                <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">{t("pl_contact_customer")}<span className="text-[#2965FB] cursor-pointer" onClick={
                    () => window.open("https://www.kudzumoney.com/contact-us", '_blank')}>{t("support_email")}</span>{t("for_access")}</p>
            </div>
        )
    }



    useEffect(() => {
    }, [cards, dispatch]);

    const closeCustomAlertModal = () => {

        setShowModel(false);
    }

    const onAcptBtnClick = async () => {
        setShowModel(false)
        if (btn1Text == t("enroll")) {
            navigate('/SetupSavingsAccount')
            dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
        } else if (btn1Text == t('home')) {
            navigate('/home')
        }

    }
    const onCancelBtnClick = () => {
        setShowModel(false)
        showAlertModal(true, '', t('savings_no_problem_title'), t('via_account_services_title'), true, false, t('okay_got_it'), '', true, beneficiarysaving, true, true);
    }

    useEffect(() => { 
        const MembershipDismisseGet = `MembershipDismissed${cards[0].CardKey}`;
        const MembershipShown = Cookies.get(MembershipDismisseGet); 
        setIsMembershipDismissed(MembershipShown);  
    }, []);
 

    const handleDismiss = () => {
        const MembershipDismisse = `MembershipDismissed${cards[0].CardKey}`; 
        Cookies.set(MembershipDismisse, 'true', { expires: 1825 });
        setIsMembershipDismissed(true); 
    };

    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone, isSubFooter) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setSavingsTheme(savingsTheme)
        setisBorderNone(isBorderNone)
        setIsSubFooter(isSubFooter)
    }

    const footerContent = () => {
        return (
            <FooterContent
                highlightText={addLineBreaks(t("Get_Access_Upgrade_Kudzu"))}
                isShowDismiss={true}
                isSubHeadingMiddla={true}
                isHelp={true}
                isShowDismissbackgroundColor={true}
                subHeaderText={addLineBreaks(t("Monthly_Deducted_text"))} image={KudzuPlusImage} type="kudzuPlusLearnMore"
                buttonEnabled={true} buttonText={t("learn_more")} isSpace={true}
                subHeaderTextColor={'#ffffff'} buttonCancelText={t('dismiss')}
                footerBtnActionCancelKudzu={handleDismiss}
                footerBtnAction={() => {
                    setShowCarouselScreensShow(false)
                    logFirebaseEvents("Manage_Membership", "Manage_Membership_Kudzu_Plus_No_Thanks_Clicked", "Manage_Membership_Kudzu_Plus_No_Thanks_Clicked", "", "");
                    dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
                    const currentPath = { currentPathFromStore: currentpath.pathname };
                    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
                   // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", t('first_three_months_charged_automatically'), true, '', false, false, true, true);
                   showAlertModalPlus(true, 
                    promoKey == PAID_PROMO_KEY ? "" : t("thanks"), 
                    promoKey == PAID_PROMO_KEY ?  addLineBreaks(t('paid_access_exclusive_fature_and_benfits_when_you_join_kudzu_plus')) : t("Try_a_Kudzu+_membership_for_three_months"), 
                    "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A",
                    promoKey == PAID_PROMO_KEY ?  t('monthly_memebership_fee_will_be_automatically_deducted') : t('first_three_months_charged_automatically'),
                      true, '', false, false, true, true);
                }} borderDirection={'even'} />
        )

    }
    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage,btn1TextColor) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)// gradient button for popup
        setLargeImage(largeImage)
        setBtn1TextColor(btn1TextColor)
    }

    const closeModelPlus = () => {
        setShowPlusModal(false);
        setShowCarouselScreensShow(false)
    }
    const onAcptBtnClickPlusModal = () => {
        setShowPlusModal(false)
        logFirebaseEvents("Manage_Membership", "Kudzu_Learn_More_Clicked", "Kudzu_Learn_More_Clicked", "", "");
        const data = { kudzuFlowFrom: "fromMembership" };
        dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
        setShowCarouselScreensShow((prev) => !prev);
    }

    const onCancelBtnClickPlusModal = () => {
        logFirebaseEvents("Manage_Membership", "Kudzu_Plus_No_Thanks_Clicked", "Kudzu_Plus_No_Thanks_Clicked", "", "");
        setShowPlusModal(false);
    }

    return (

        <HomeLayout>
            <HomeHeader heading={addLineBreaks(t("Manage_Kudzu_Memebership"))} isHeaderCaption={true} />
            {showCarouselScreenShow &&
                <MemnershipEnrollmentScreens />}
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
       animate__animated animate__fadeInRight '>
                <DynamicCard
                    header={true}
                    footer={false}
                    CardRadius={true}
                    HeaderRadius={true}
                    isWhite={true}
                    cardWidth={width.homeCard}
                >

                    <div className="lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500]  lg:text-[26px] md:text-[22px]  sm:text-[20px] text-[20px]  leading-[36px] font-hanken-grotesk sm:mx-0 mx-4">
                        {t('manage_membership')}
                    </div>

                    <div className='border-t-[2.5px] border-[#A3CEBB]
                     flex justify-center flex-col sm:mx-0 mx-4'>

                        <div className='md:h-[300px] sm:h-[135px] h-[155px] border-b-[1px]  flex justify-center border-[#D1E7DD] items-center sm:mx-0 mx-4'>
                            <div className='sm:w-[83%] w-full'>
                                <div >
                                    <p className='font-hanken-grotesk text-[#262B3A] 
                                        uppercase lg:text-[13px] md:text-[12px] 
                                        sm:text-[11px] text-[13px]  font-[600] tracking-[2px] md:pt-0 lg:pt-0  pt-10 md:pb-8 pb-5 opacity-[50%] '>
                                        {t("Membership").toLocaleUpperCase()}</p>
                                    <div className='flex flex-row justify-start items-center gap-40 sm:w-auto w-full mb-24'>



                                        <div>
                                            <p className="font-hanken-grotesk font-[700] md:text-[18px] sm:text-[14px] text-[14px]  text-[#262B3A]
                                             cursor-pointer pointer-events-none">
                                                {t('Kudzu')}
                                            </p>
                                        </div>
                                        <img src={check_img} className="lg:w-[20px] lg:h-[20px] md:w-[16px] md:h-[16px] sm:w-[13px] sm:h-[13px] w-[15px] h-[15px] sm:ml-5" />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {loading && <Loader />}
                </DynamicCard>
                {!isMembershipDismissed && footerContent()}
            </div>
            <CustomAlertModel isOpen={showModel}
                modalBg={!isSubFooter && 'bg-[#E4F1EB]'}
                btn1BorderColor={!isSubFooter && '#30BC89'}
                btn1TextColor={!isSubFooter && '#FEFAEE'}
                btn1BrExist={!isSubFooter && true}
                btn2TextColor={!isSubFooter && '#559C7E'}
                btn1BgColor={!isSubFooter && '#30BC89'}
                onClose={closeCustomAlertModal}
                image={modelImage}
                highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                    <span className={`${HeaderMsgStyles} ${savingsTheme ? 'text-[#0C4437]' : 'text-[#0C4437]'}`}> {headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                isBorderNone={isBorderNone}
                subFooter={isSubFooter && subComponent()}
            />
            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                image={modelImage}
                carousel={carousel}
                summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                gradientButton={gradientButton}
                largeImage={largeImage}
                btn2TextColor={'#779CE5'}

            />
            {isLoading && <Loader />}
        </HomeLayout>


    )
}

export default ManageMembershipKudzu;
